import React from 'react';

import ReasonTransfers  from 'components/Tvendo/Inventory/Operations/Kardex/ReasonTransfersFile.js';

export default function () {
  return <ReasonTransfers  />;
}